import React, { useEffect, useRef, useState } from 'react'
import { useGetProductsQuery } from '../../store/api/productsApi'
import { useGetSuppliersQuery } from '../../store/api/supplierApi'
import { useGetNotificationsQuery } from '../../store/api/notificationApi'
import Swal from 'sweetalert2'
import { useCreateRequestProductMutation, useCreateRequestOrderMutation, useGetLastGenIdQuery } from '../../store/api/orderProductApi'
import { useGetBusinessQuery } from '../../store/api/businessApi'
import { useGetUserRolesQuery } from '../../store/api/userAuthApi'
import { useGetUnitsQuery } from '../../store/api/UnitsApi'
import Logo from '../tools/Logo'
import Select from 'react-select';
import PDFPurchaseOrderGenerator from '../tools/PDFPurchaseOrderGenerator'
import { useGetCreditPurchaseQuery } from '../../store/api/creditPurchaseApi'
import { useDrafts } from '../tools/useDrafts'
import { DotLoader } from 'react-spinners';

const initialVlaues = {
  isAdmin: false,
  isStoreKeeper: true,
};



const initialProductOrder = {
  productName: '',
  supplierName: '',
  requestedqty: 0,
  Recievedqty: 0,
  ProductsId: "",
  supplierId: "",
  UnitesId: "",
  UnitName: "",
  Description: ""
}


export default function OrderProducts() {
  const { drafts, handleUpdateDraft, handleRemoveDraft } = useDrafts('orders');
  let userLogedInId = localStorage.getItem("UserData") != null ? JSON.parse(localStorage.getItem("UserData")).id == null ? 0 : JSON.parse(localStorage.getItem("UserData")).id : 0;
  const [selectedOption, setSelectedOption] = useState(null);
  const userRoles = useGetUserRolesQuery(userLogedInId, { pollingInterval: 10000 }).data;
  var userRolesData = userRoles ?? [];
  const [isSaved, setSaved] = useState(false)
  const [isOrdered, setOrdered] = useState(false)

  userRolesData.map((user) => (
    user.roles.map((role) => {
      if (role.isAdmin == true) {
        initialVlaues.isAdmin = role.isAdmin;
        initialVlaues.isStoreKeeper = false;
      } else if (role.isStoreKeeper === true) {
        initialVlaues.isStoreKeeper = role.isStoreKeeper;
        initialVlaues.isAdmin = false;
      }
    })
  ));

  const { refetch: refetchNotifications } = useGetNotificationsQuery()

  const [dataBusiness, setBusinessData] = useState([]);
  const [dataCreditPurchase, setCreditPurchaseData] = useState([]);
  const [suppId, setSupplierId] = useState(null);
  const [supplierName, setSupplierName] = useState(null);
  const [Description, setDescription] = useState('');



  // Fetch Business
  const { data: businnes } = useGetBusinessQuery();
  const { data: creditPurchase } = useGetCreditPurchaseQuery();

  useEffect(() => {
    if (creditPurchase && Array.isArray(creditPurchase)) {
      setCreditPurchaseData(creditPurchase)
    }
  }, [creditPurchase]);





  useEffect(() => {
    if (businnes && Array.isArray(businnes)) {
      setBusinessData(businnes)
    }
  }, [businnes]);

  const [Units, setUnitsList] = useState([]);
  const { data: UnitsList } = useGetUnitsQuery();
  useEffect(() => {
    if (UnitsList) {
      setUnitsList(UnitsList);
    }
  }, [UnitsList]);



  const [shouldExcludeLastRow, setShouldExcludeLastRow] = useState(false)
  let [generateId, setGenId] = useState(null);
  const [createRequestOrders] = useCreateRequestProductMutation()
  const [createRequestOrder] = useCreateRequestOrderMutation()
  const [products, setProducts] = useState([])
  const [suppliers, setSuppliers] = useState([])
  let [getLastId, setGetLastId] = useState(null)

  const [formData, setFormData] = useState(initialProductOrder)

  const [formDataList, setFormDataList] = useState([]);

  const { data: lastId, refetch: refetchLastId } = useGetLastGenIdQuery();

  const { data: product } = useGetProductsQuery({
    refetchOnMountOrArgChange: false
  });




  useEffect(() => {
    if (product) {
      setProducts(product)
    }
  }, [product]);


  useEffect(() => {
    if (lastId) {
      setGetLastId(lastId);
    }
  }, [lastId]);



  const { data: supplier } = useGetSuppliersQuery({
    refetchOnMountOrArgChange: true
  })
  useEffect(() => {
    if (supplier) {
      setSuppliers(supplier)
    }
  }, [supplier])

  const productOptions = products
    ?.filter((pro) => pro.qty >= 0 && pro.isActive === 'active')
    .map((pro) => ({
      value: pro.id,
      label: pro.name
    }))

  const handleFormChange = (e) => {
    const { name, value } = e.target
    if (name === 'Description') {
      setDescription(value);
    }
    setFormData({
      ...formData,
      [name]: value
    })
  }


  const initializedRef = useRef(false);

  useEffect(() => {
    if (drafts && drafts.length > 0 && !initializedRef.current) {
      setDescription(drafts.at(0)?.Description)
      setSupplierId(drafts.at(0)?.supplierId)
      setSupplierName(drafts.at(0)?.supplierName)
      setFormData({ ...formData, supplierId: drafts.at(0)?.supplierId, supplierName: drafts.at(0)?.supplierName, Description: drafts.at(0)?.Description })
      setFormDataList([...drafts]);
      setSaved(true);

      initializedRef.current = true; // Mark as initialized
    }
  }, [drafts, getLastId]);

  const handleSelectChange = (Option) => {
    setSelectedOption(Option);

    if (Option != null) {
      const selectedProductId = parseInt(Option.value)
      const selectedProduct = products.find((product) => product.id === selectedProductId)
      const selectedProductUnitesId = selectedProduct.unitesId
      const selectedUnit = Units.find((unit) => unit.id === selectedProductUnitesId)

      setFormData({
        ...formData,
        ProductsId: selectedProductId,
        productName: selectedProduct.name,
        UnitesId: selectedProductUnitesId,
        UnitName: selectedUnit.name,
        ...(supplierName && { supplierName })
      })
    }
  }




  const handleSupplierSelectChange = (name, selectedOption) => {
    if (selectedOption.target.value !== "Select Supplier") {
      const selectSupplierId = parseInt(selectedOption.target.value);
      const selectedSupplier = suppliers.find(
        (con) => con.id === selectSupplierId
      );


      setSupplierId(selectedOption.target.value);

      setFormData({
        ...formData,
        [name]: selectedOption.target.value,
        supplierName: selectedSupplier?.name
      })
    }
  }


  

  const handleAddToList = (e) => {
    setSelectedOption(null)
    if (formData.supplierId && formData.Description) {
      setSaved(true);
    }
    e.preventDefault()
    const isProductExists = formDataList.some((data) => data.productName === formData.productName)

    if (isProductExists) {
      updateQuantities(formDataList, formData);
    } else if (Object.values(formData).some((value) => value === '')) {

      Swal.fire({
        title: 'Please fill in all fields 📥.',
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `
        }
      })

    } else {
      if (formData.requestedqty === 0) {
        Swal.fire("Invalid quanitity!");
      } else {


        handleUpdateDraft("orders", { ...formData, supplierId: suppId });
        setFormDataList([...formDataList, { ...formData, supplierId: suppId, Description: Description }]);
        if (shouldExcludeLastRow) {
          setShouldExcludeLastRow(!shouldExcludeLastRow);
        }
        setFormData({ ...initialProductOrder, supplierId: suppId, supplierName: supplierName, Description: Description });
        setSelectedOption(null);
      }

    }


  }

  const updateQuantities = (formDataList, formData) => {
    const oldProduct = formDataList.filter((data) => data.productName === formData.productName);
    oldProduct.at(0).requestedqty = parseInt(oldProduct.at(0).requestedqty) + parseInt(formData.requestedqty);
    const oldFormDataList = formDataList.filter((data) => data.productName !== formData.productName);
    setFormDataList([...oldFormDataList, ...oldProduct]);
    setFormData({ ...initialProductOrder, supplierId: suppId, Description: Description });
    handleUpdateDraft("orders", { ...formData, supplierId: suppId });
  }


  const handleRemove = (e, row) => {
    e.preventDefault()
    handleRemoveDraft(row.ProductsId)
    const newData = formDataList.filter((item) => item !== row)
    if (newData.length > 0) {
      setFormDataList(newData)
    }
    else {
      setFormDataList([]);
      setSaved(false)
      setFormData(initialProductOrder);
      localStorage.removeItem('orders');
    }
  }

  const RestData = (e, type) => {
    e.preventDefault()
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to ${type} this request details !!!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${type} it!`
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('orders');
        setFormDataList([]);
        setFormData(initialProductOrder);
        setSaved(false)
      }
    })

  }


  const generateUniqueId = (name, length, genId) => {


    let lastNumber = 100;
    let randomString = '';
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';


    if (genId) {

      if (genId && genId.trim() !== '') {
        const index = genId.lastIndexOf('-');
        const lastPart = genId.substring(index + 1);

        lastNumber = parseInt(lastPart, 10);
        if (!isNaN(lastNumber)) {
          lastNumber++;
        }
      }

    }

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars[randomIndex];
    }
    let gen = `${name}-${randomString}-${lastNumber}`;
    return gen;
  }


  const SendRequestOrder = async () => {
    var data = formDataList?.length > 0 ? formDataList[0] : {};
    const generateId = generateUniqueId("PLM", 6, getLastId?.genId);
    const requestData = {
      id: 0,
      supplierId: data.supplierId,
      GenId: generateId,
      usersId: userLogedInId,
    };

    const savedOrderData = await createRequestOrder(requestData);
    setOrdered(true)
    return savedOrderData;
  };




  const handleOrderCreate = async (type, event) => {

    setShouldExcludeLastRow(!shouldExcludeLastRow);

    event.preventDefault();
    let allSuccess = true;
    let msg = '';

    

    const productOrderResponse = await SendRequestOrder();
   

    if (productOrderResponse.data.status === 200) {
      for (const item of formDataList) {
        const movementResponse = await createRequestOrders({ ...item, GenId: productOrderResponse.data.requestOrder.genId, isArrived: false, IsWaiting: true, Amount: 0, RequestOrderId: productOrderResponse.data.requestOrder.id });

        if (movementResponse.data.status !== 200) {
          allSuccess = false;
          msg = movementResponse.data.message;
          break;
        } else {
          msg = movementResponse.data.message;
        }
      }

      await refetchNotifications();
      await refetchLastId();

      if (allSuccess) {
        setSaved(false);
        if (type === 'download') {
          PDFPurchaseOrderGenerator(productOrderResponse.data.requestOrder?.genId, formDataList);
        }
        setFormDataList([]);
        setFormData(initialProductOrder)
        setShouldExcludeLastRow(!shouldExcludeLastRow);
        setGenId(null);
        setOrdered(false)

        Swal.fire({
          title: 'Success!',
          text: msg,
          icon: 'success',
          confirmButtonText: 'Done'
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: msg,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    }

    setFormData(formData);
    setFormDataList([])
    localStorage.removeItem('orders');
    setDescription('')

  };


  const ConfirmHandle = async (type, event) => {
    event.preventDefault();
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to ${type} this request details !!!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${type} it!`
    }).then((result) => {
      if (result.isConfirmed) {
        handleOrderCreate(type, event);
      }
    })
  }


  const createPage = () => {
    if (formDataList.length == 0) {
      return <div className="text-center fs-4 text-muted mt-5">Order invoice goes here</div>
    }
    const pageData = formDataList;

    return (
      <div>
        <div className="text-center ">
          <div className="row">

            <div className="col-12 mt-1 mb-3">
              <h4 className="text-start font-size-h6">Order Product List </h4>
            </div>
          </div>
        </div>

        <div className="table-responsive1">
          <table className="table table-striped">
            <thead className="table-dark">
              <tr>
                <th className="font-size-h6 text-center">No.</th>
                <th className="font-size-h6 text-center">Name</th>
                <th className="font-size-h6 text-center">Quantity</th>
                <th className="font-size-h6 text-center">Unit</th>

                <th className={shouldExcludeLastRow ? 'd-none' : 'text-center'}>Action</th>
              </tr>
            </thead>
            <tbody>
              {pageData.map((item, index) => (
                <>
                  <tr key={index} className="h-25" >
                    <td className="text-center">
                      {index + 1}
                    </td>
                    <td className="text-center">
                      {item.productName}
                    </td>
                    <td className="text-center">
                      <span className="badge1 1badge-pill badge-primary1">{item.requestedqty}</span>
                    </td>
                    <td className="text-center">
                      <span className="badge1 1badge-pill badge-primary1">{item.UnitName}</span>
                    </td>

                    <td className={shouldExcludeLastRow ? 'd-none' : 'text-center'}>
                      <button
                        className={shouldExcludeLastRow ? 'd-none' : 'btn bg-danger text-white'}
                        onClick={(e) => handleRemove(e, item)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>


      </div>
    )
  }

  const canAdd = [
    formData.productName,
    formData.requestedqty,
    formData.ProductsId,
    formData.supplierId,
    formData.UnitName,
    formData.Description,
  ].every(Boolean)




  return (
    <>
      <div className="block1 m-2 p-1">
        <div className="row border-bottom">
          <div className="col-lg-4 col-md-6 col-sm-5 col-12 mb-2 fs-3">Purchase Order</div>
        </div>

        <div className="row ">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-12">
            {/* <form> */}
            <div className="row mt-4 me-1  mx-1 ">


              {
                initialVlaues.isAdmin === true ? <>
                  {
                    dataBusiness && dataBusiness.length > 0 && dataBusiness[0].integrated == true ? (<div className="mt-2">
                      <div className="mb-3">
                        <div className="row">
                          <label
                            htmlFor="SelectSupplier"
                            className="form-label text-start"
                          >
                            Supplier
                          </label>
                        </div>
                        <select

                          className="form-select"
                          style={{ height: '45px' }}
                          aria-label="Default select example"
                          id="SelectSupplier"
                          onChange={(e) => handleSupplierSelectChange('supplierId', e)}
                          value={
                            formData.supplierId === ""
                              ? "Select Supplier"
                              : formData.supplierId
                          }
                        >
                          <option selected>Select Supplier</option>
                          {dataCreditPurchase?.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>) : <div className="mt-2">
                      <div className="mb-3">
                        <div className="row">
                          <label
                            htmlFor="SelectSupplier"
                            className="form-label text-start"
                          >
                            Supplier
                          </label>
                        </div>
                        <select
                          disabled={isSaved}
                          className="form-select"
                          style={{ height: '45px' }}
                          aria-label="Default select example"
                          id="SelectSupplier"
                          onChange={(e) => handleSupplierSelectChange('supplierId', e)}
                          value={
                            formData.supplierId === ""
                              ? "Select Supplier"
                              : formData.supplierId
                          }
                        >
                          <option selected>Select Supplier</option>
                          {suppliers?.map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  }

                </>




                  : (<></>)
              }

              <div className="mt-2">
                <div className="row">
                  <label
                    htmlFor="notificationQuantity"
                    className="form-label text-start"
                  >
                    Purpose?
                  </label>
                </div>
                <textarea
                  disabled={isSaved}
                  className="form-control "
                  name="Description"
                  placeholder="write here the reason for consuming"
                  value={formData.Description}
                  onChange={handleFormChange}
                />
              </div>

              <div className="mt-2">
                <div className="mb-3">
                  <div className="row">
                    <label
                      htmlFor="SelectProduct"
                      className="form-label text-start"
                    >
                      Products
                    </label>
                  </div>


                  <div className="d-flex mb-3">
                    <div className="input-group flex-grow-1 me-2">
                      <Select
                        className='w-100'
                        name='ProductsId'
                        inputId="SelectProduct"
                        options={productOptions}
                        onChange={handleSelectChange}
                        value={selectedOption}
                        placeholder="Select Product"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            height: '40px',
                            minHeight: '40px',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>

                    <div className="input-group" style={{ width: '150px' }}>
                      <select
                        disabled={true}
                        className="form-control"
                        style={{ height: '40px' }}
                        aria-label="Default select example"
                        id="SelectUnits"
                        name='UnitesId'
                        onChange={handleFormChange}
                        value={formData.UnitesId || 0}
                      >
                        <option value={0}>Units</option>
                        {Units.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                  </div>


                </div>
              </div>

              <div className="col-md-12  mt-2">
                <div className="row">
                  <label htmlFor="notificationQuantity" className="form-label text-start">
                    How many quantity?
                  </label>
                </div>
                <div className="input-group">
                  <input

                    name="requestedqty"
                    style={{ height: '45px' }}
                    type="number"
                    min={'1'}
                    className="form-control numericInput"
                    id="notificationQuantity"
                    value={formData.requestedqty}
                    onChange={handleFormChange}
                  />
                </div>
              </div>


              <div className="text-start">
                <button
                  disabled={!canAdd}
                  type="button"
                  className="btn btn-primary mt-2 px-3 pe-3 pt-2 pb-2 mt-3 mb-sm-5"
                  onClick={handleAddToList}
                >
                  Add To The List
                </button>
              </div>
            </div>
            {/* </form> */}
          </div>
          {!isOrdered ? (<div className="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-12">
            <div className="mt-3 mb-3">

              {formDataList.length > 0 ? (
                <div className="d-flex justify-content-end">
                  <div className="me-2">
                    <button
                      title='Clear'
                      onClick={(e) => RestData(e, 'Clear')}
                      className='btn btn-secondary p-2'>
                      <Logo _width={25} name={'../image/icons/clear-01.svg'} _height={25} _color={'#FFFFFF'} />
                    </button>
                  </div>
                  <div className="me-2">
                    <button
                      title='Download'
                      type='submit'
                      onClick={(e) => ConfirmHandle("download", e)}
                      className='btn btn-secondary p-2'>
                      <Logo _width={25} name={'../image/icons/download.svg'} _height={25} _color={'#FFFFFF'} />
                    </button>
                  </div>

                  <div className="me-3">
                    <button
                      title='Save'
                      type='submit'
                      onClick={(e) => ConfirmHandle("save", e)}
                      className='btn btn-success p-2'>
                      <Logo _width={25} name={'../image/icons/save.svg'} _height={25} _color={'#FFFFFF'} />
                    </button>
                  </div>



                </div>

              ) : (
                <></>
              )}
            </div>


            <div
              className="position-relative"
            >
              {createPage()}
            </div>
          </div>) : (<div className='col-sm-12 col-md-12 col-lg-12 col-xl-8 col-12'>
            <div className='vh overflow-hide d-flex justify-content-center align-items-center'>
              <DotLoader color='#01574E' />
            </div>
          </div>)}

        </div>

      </div>
    </>
  )
}
